/**
 * The "EA Code" input in EditProposal renders once per parent standard (e.g.
 * "ISO/IEC 27001"), below every child cycle row (CMF-Basic, Initial Audit
 * Stage 1&2, Surveillance 1st/2nd, Recertification) — there is no separate
 * EA Code control per child. But the save payload sends eaCodeSectorIds
 * independently for the parent AND for each child, and nothing ever wrote
 * to the child's own value, so every child always sent [].
 *
 * A project's audit-process standard (e.g. "Initial Certification Stage
 * 1&2") is created FROM one of those child proposal_standard_items, not the
 * parent — so its EA Code lookup (keyed to that child's id) always came back
 * empty even when the shared EA Code box further up clearly had a value.
 *
 * This intentionally stays at the proposal_standard_item level (parent or
 * child), never falling back to the company's sector — that company-level
 * fallback was the earlier, since-corrected bug this per-standard-item model
 * replaced.
 */
export const resolveChildEaCodeSectorIds = (childEaCodeSectorIds, parentEaCodeSectorIds) => {
  if (Array.isArray(childEaCodeSectorIds) && childEaCodeSectorIds.length > 0) {
    return childEaCodeSectorIds;
  }
  return Array.isArray(parentEaCodeSectorIds) ? parentEaCodeSectorIds : [];
};
